import { render, staticRenderFns } from "./rk-echarts.vue?vue&type=template&id=055843b6&"
import script from "./rk-echarts.vue?vue&type=script&lang=ts&"
export * from "./rk-echarts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports